module.exports = __webpack_public_path__ + "static/media/WebScreenshot5.3a925aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WebScreenshot5.png
// module id = 33
// module chunks = 0